import { groupFromDto } from '../../group.dto';

export function domainsFromDto(domains) {
    return domains.map((domain) => ({...domain, groups: groupsFromDto(domain.groups)}));
}

function groupsFromDto(dto) {
    const groups = dto.map(groupFromDto).sort((a, b) => a.cname.localeCompare(b.cname));
    const domains = groups.filter(({type}) => type === 'AD_DOMAIN');
    const ous = groups.filter(({type}) => type === 'AD_OU');
    const children = (ou) => groups.filter((g) => g.parentName === ou.cname);
    return domains.concat(...ous.map((ou) => [ou, ...children(ou)]));
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.functions.js